import Button from 'src/common/ui-kit/Button/Button'
import Icon from 'src/common/ui-kit/Icon/Icon'
import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import {
  buyTokenAmountAtom,
  buyTokenAtom,
  sellTokenAmountAtom,
  sellTokenAtom,
  successfulTxHashAtom,
} from '../../stores/trade-store'
import { getExplorerUrl } from 'src/common/utils/web3/getExplorerUrl'
import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import TokenExchangePair from 'src/common/components/TokenExchangePair'
import { useTranslation } from 'react-i18next'

interface SwapSuccessProps {
  header: string
}

const SwapSuccess: React.FC<SwapSuccessProps> = ({ header }) => {
  const { t } = useTranslation('trade')
  const navigate = useNavigate()

  const sellToken = useAtomValue(sellTokenAtom)
  const buyToken = useAtomValue(buyTokenAtom)
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)
  const buyTokenAmount = useAtomValue(buyTokenAmountAtom)

  const successfulTxHash = useAtomValue(successfulTxHashAtom)

  const chain = useActiveOrDefaultChain()

  const handleViewTransaction = () => {
    const url = getExplorerUrl({
      type: 'tx',
      chainId: chain.id,
      hash: successfulTxHash,
    })

    window.open(url, '_blank')
  }

  const handleBackToTrade = () => {
    navigate('/trade')
  }

  return (
    <>
      <div className='paper p-4 mb-4 flex flex-col justify-center items-center'>
        <Icon
          name='success-status'
          className='mb-2'
          color='primary'
          size={35}
        />
        <div className='typo-title3 text-main-accent mb-4'>{header}</div>
        {sellToken && buyToken && (
          <TokenExchangePair
            tokenIn={sellToken}
            tokenOut={buyToken}
            amountIn={sellTokenAmount}
            amountOut={buyTokenAmount}
          />
        )}
      </div>
      <div className='flex gap-4'>
        <Button
          className='w-full px-2'
          onClick={handleViewTransaction}
          variant='outlined'
        >
          {t('swapSuccess.viewTransaction')}
        </Button>
        <Button className='w-full px-2' onClick={handleBackToTrade}>
          {t('swapSuccess.backToTrade')}
        </Button>
      </div>
    </>
  )
}

export default SwapSuccess
